/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import * as Styled from "./styles";

import { Button, CircularProgress, Container, Typography } from "@mui/material";
import { ReturnButton } from "components/ReturnButton";
import { useAuth } from "shared/providers/auth";
import SignatureCanvas from "react-signature-canvas";
import toast from "react-hot-toast";
import { sendSignature } from "requests/Signature";

const ModalSignature: React.FC<{
  onClick?: () => void;
  onLoad: () => void;
  typeSignatures: string[];
  idRecord: number;
}> = ({ onClick, onLoad, typeSignatures, idRecord }) => {
  const { user } = useAuth();

  const [loading, setLoading] = React.useState<boolean>(false);
  const [signatureDoctor, setSignatureDoctor] = React.useState<any>();
  const [signaturePatient, setSignaturePatient] = React.useState<any>();

  const sigCanvasPatient = React.useRef<SignatureCanvas>(null);

  const saveSignaturePatient = () => {
    if (sigCanvasPatient.current) {
      const dataURL = sigCanvasPatient.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setSignaturePatient(dataURL);
    }
  };

  const sigCanvasDentist = React.useRef<SignatureCanvas>(null);

  const saveSignatureDentist = () => {
    if (sigCanvasDentist.current) {
      const dataURL = sigCanvasDentist.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setSignatureDoctor(dataURL);
    }
  };

  const clearSignaturePatient = () => {
    sigCanvasPatient.current?.clear();
    setSignaturePatient(null);
  };

  const clearSignatureDentits = () => {
    sigCanvasDentist.current?.clear();
    setSignatureDoctor(null);
  };

  const sendSignatures = async () => {
    if (!signaturePatient && typeSignatures.includes("patient")) {
      toast.error("Preencha a assinatura do paciente");
      return false;
    }
    if (!signatureDoctor && typeSignatures.includes("dentist")) {
      toast.error("Preencha a assinatura do dentista");
      return false;
    }

    setLoading(true);

    try {
      setLoading(false);
      if (typeSignatures.includes("dentist")) {
        const { status } = await sendSignature(
          {
            idRecord: idRecord,
            signatureType: "dentist",
            signature: signatureDoctor,
          },
          user.data.id
        );

        if (![200, 201].includes(status)) {
          toast.error("Falha ao enviar a assinatura");
          return false;
        }
      }

      if (typeSignatures.includes("patient")) {
        const { status } = await sendSignature(
          {
            idRecord: idRecord,
            signatureType: "patient",
            signature: signaturePatient,
          },
          user.data.id
        );

        if (![200, 201].includes(status)) {
          toast.error("Falha ao enviar a assinatura");
          return false;
        }
      }

      toast.success("Assinatura enviada com sucesso!");
      onLoad();
      onClick && onClick();
    } catch (e: any) {
      setLoading(false);
    }
    setLoading(false);
  };

  return (
    <Container maxWidth="xl">
      {loading ? (
        <CircularProgress />
      ) : (
        <>
          <ReturnButton title="Assinaturas pendentes" onClick={onClick} />

          <Styled.BoxAll>
            {typeSignatures.includes("patient") && (
              <Styled.BoxClinicalSignature className="boxValue">
                <Typography
                  variant="h5"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  Assinatura do Paciente{" "}
                  <Button onClick={clearSignaturePatient} className="no-print">
                    Limpar
                  </Button>
                </Typography>
                <div className="boxSignature">
                  <SignatureCanvas
                    onEnd={saveSignaturePatient}
                    ref={sigCanvasPatient}
                    penColor="black"
                    canvasProps={{
                      height: 200,
                      className: "sigCanvas",
                      width: 680,
                    }}
                  />
                </div>
              </Styled.BoxClinicalSignature>
            )}

            {typeSignatures.includes("dentist") && (
              <Styled.BoxClinicalSignature className="boxValue">
                <Typography
                  variant="h5"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  Assinatura do Dentista{" "}
                  <Button onClick={clearSignatureDentits} className="no-print">
                    Limpar
                  </Button>
                </Typography>
                <div className="boxSignature">
                  <SignatureCanvas
                    onEnd={saveSignatureDentist}
                    ref={sigCanvasDentist}
                    penColor="black"
                    canvasProps={{
                      height: 200,
                      className: "sigCanvas",
                      width: 680,
                    }}
                  />
                </div>
              </Styled.BoxClinicalSignature>
            )}

            <Button sx={{ margin: "0 20px" }} onClick={sendSignatures}>
              Enviar
            </Button>
          </Styled.BoxAll>
        </>
      )}
    </Container>
  );
};

export { ModalSignature };
